import './styles.css';
import CardHeader from "../../../antd/components/CardHeader";
import { useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import { PleaModel } from '../../../Models/PleaModel';
import PaginationTabs from '../../../Components/Shared/PaginationTabs';
import { Table } from 'antd';
import Loader from '../../../Components/Shared/Loader';
import { GetAllPleaSummaryCostsByPleaId } from '../../../API/PleaSummaryCostsAPI';
import { CostSummary } from '../../../Models/CostSummary';
import { CommandResult } from '../../../Models/CommandResult';
import { VersionEnum } from '../../../Models/VersionEnum';


export default function BudgetPlea() {
    const { id, pleaId } = useParams();
    const [plea, setPlea] = useState<PleaModel>();
    const [pag, setPag] = useState<number>(0);
    const [key, setKey] = useState<number>(0);
    const [costSummaries, setCostSummaries] = useState<CostSummary[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const columns = ["Resumo de Custos", "Cronograma Financeiro", "Gastos com RH", "Gastos com Terceiros"];

    useEffect(() => {
        if (pleaId) {
            fetchPleaSummaryCosts();
        }
    }, [pleaId]);

    const fetchPleaSummaryCosts = async () => {
        try {
            setLoading(true);
            const result = await GetAllPleaSummaryCostsByPleaId(pleaId!);
            setCostSummaries(result.data || []);
        } catch (error) {
            console.error("Error fetching cost summaries:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleVersionClick = (version: number) => {
        // Implementar a navegação ou ação desejada ao clicar na versão
        console.log("Version clicked:", version);
    };

    const columnsCostSummary = [
        {
            title: "Versão",
            dataIndex: "version",
            key: "version",
            render: (version: number) => (
                <a onClick={() => handleVersionClick(version)} style={{ cursor: 'pointer' }}>
                    {version}
                </a>
            ),
        },
        {
            title: "Nacional",
            dataIndex: "national",
            key: "national",
            render: (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        },
        {
            title: "Importado",
            dataIndex: "imported",
            key: "imported",
            render: (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            render: (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        },
        {
            title: "Realizado",
            dataIndex: "realized",
            key: "realized",
            render: (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        },
        {
            title: "Saldo",
            dataIndex: "balance",
            key: "balance",
            render: (value: number) => value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        }
    ];

    return (
        <div className='card' style={{ margin: '10px' }}>
            {loading && <Loader />}
            <CardHeader
                pageName={"Orçamento " + plea?.version + " - " + plea?.bankName}
                hasPageBefore={true}
                pageBeforeName={'Cadastro'}
                linkPageBefore={`/plea/financial/finep/${id}/${pleaId}`}
            />
            <div className='main-container'>
                <PaginationTabs setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={columns} />
            </div>
            {pag === 0 && (
                <div className="container-table">
                    <Table
                        columns={columnsCostSummary}
                        dataSource={costSummaries}
                        rowKey="id"
                        loading={loading}
                        pagination={{
                            pageSize: 5,
                            showSizeChanger: true,
                            pageSizeOptions: ["5", "10", "15"]
                        }}
                    />
                </div>
            )}
        </div>
    );
}